module.exports = __webpack_public_path__ + "img/plan-0.579f986c.png";